export const INITIAL_STATE_TALHAO = {
  id: null,
  idPropriedade: null,
  latitude: null,
  longitudade: null,
  nome: null,
  cultura: null,
  observacao: null,
}

export const INVALID_FIELDS_TALHAO = {
  nome: "",
}
